<template>
  <div id="app">
    <el-container class="app-container">
      <el-header class="app-header">
        <div class="header-content">
          <div class="logo-section">
            <img src="./assets/img/lllogo.png" alt="公司logo" class="logo-img" />
          </div>
          <el-menu
            :default-active="defaultActive"
            class="nav-menu"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
          >
            <el-menu-item index="/" class="nav-item">首页</el-menu-item>
            <el-menu-item index="/goin" class="nav-item">走进中经鑫</el-menu-item>
            <el-menu-item index="/download" class="nav-item">下载APP</el-menu-item>
          </el-menu>
        </div>
      </el-header>
      <el-main class="app-main">
        <router-view class="router-view" />
      </el-main>
      <div class="app-footer">
        <div class="footer-content">
          <div class="footer-links">
            <ul class="links-container">
              <li class="link-column">
                <h3 class="column-title">关于建企悦</h3>
                <div class="link-items">
                  <span class="link-item">关于我们</span>
                  <span class="link-item">用户协议</span>
                  <span class="link-item">隐私权政策</span>
                  <span class="link-item">免责声明</span>
                  <span class="link-item">投诉指引</span>
                  <span class="link-item">意见反馈</span>
                </div>
              </li>
              <li class="link-column">
                <h3 class="column-title">新闻资讯</h3>
                <div class="link-items">
                  <span class="link-item">公司新闻</span>
                  <span class="link-item">行业动态</span>
                </div>
              </li>
              <li class="link-column">
                <h3 class="column-title">产品中心</h3>
                <div class="link-items">
                  <span class="link-item">介绍视频</span>
                  <span class="link-item">管理模式</span>
                  <span class="link-item">平台目标</span>
                  <span class="link-item">功能模块</span>
                </div>
              </li>
              <li class="link-column">
                <h3 class="column-title">联系建企悦</h3>
                <div class="link-items">
                  <span class="link-item">商务合作：sw@jianqiyue.com</span>
                  <span class="link-item">地址：北京市海淀区西翠路9号瑞成御朗酒店公寓5021</span>
                </div>
              </li>
              <li class="qr-column">
                <div class="qr-section">
                  <h3 class="column-title">建企悦APP</h3>
                  <img src="./assets/img/jqy-app.jpeg" alt="APP二维码" class="qr-img" />
                </div>
                <div class="qr-section">
                  <h3 class="column-title">微信公众号</h3>
                  <img src="./assets/img/gongzhonghao.png" alt="微信二维码" class="qr-img" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-copyright">
          <div class="copyright-content">
            <span class="copyright-text">版权所有：北京中经鑫（北京）建筑科技有限公司 @2022 增值电信业务经营许可证：京82-20210267 </span>
            <span class="icp-link">
              <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备 2021028518号-2</a>
            </span>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      // isShow: false
      isShow: true
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color: #f5f5f5;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-container {
  min-height: 100vh;
}

.app-header {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 0;
  height: auto;
  
  .header-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // padding: 10px 0;
    
    .logo-section {
      .logo-img {
        height: 60px;
        width: auto;
      }
    }
    
    .nav-menu {
      border: none;
      background: transparent;
      
      .nav-item {
        font-size: 16px;
        font-weight: 500;
        padding: 0 25px;
        height: 60px;
        line-height: 60px;
        
        &.is-active {
          color: #14679f;
          border-bottom: 3px solid #14679f;
        }
        
        &:hover {
          background: transparent;
          color: #14679f;
        }
      }
    }
  }
}

.app-main {
  flex: 1;
  width: 1200px;
  margin: 20px auto;
  padding: 0 !important;
  
  .router-view {
    min-height: calc(100vh - 200px);
  }
}

.app-footer {
  background: #14679f;
  color: #ffffff;
  margin-top: auto;
  
  .footer-content {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0 20px;
    
    .footer-links {
      .links-container {
        display: flex;
        justify-content: space-between;
        list-style: none;
        padding: 0;
        margin: 0;
        
        .link-column {
          flex: 1;
          padding: 0 20px;
          
          .column-title {
            font-size: 20px;
            color: #d4edff;
            margin-bottom: 20px;
            padding-bottom: 10px;
            border-bottom: 1px solid #d4edff;
          }
          
          .link-items {
            display: flex;
            flex-direction: column;
            
            .link-item {
              color: #f7f7f7;
              font-size: 14px;
              margin-bottom: 12px;
              cursor: pointer;
              transition: color 0.3s ease;
              
              &:hover {
                color: #ffffff;
              }
            }
          }
        }
        
        .qr-column {
          flex: 1;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          
          .qr-section {
            margin-bottom: 20px;
            
            &:last-child {
              margin-bottom: 0;
            }
            
            .column-title {
              font-size: 20px;
              color: #d4edff;
              margin-bottom: 15px;
              padding-bottom: 10px;
              border-bottom: 1px solid #d4edff;
            }
            
            .qr-img {
              width: 150px;
              height: 150px;
              padding: 10px;
              background: #ffffff;
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
  
  .footer-copyright {
    background: #125688;
    padding: 15px 0;
    
    .copyright-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .copyright-text {
        color: #ffffff;
        font-size: 14px;
        line-height: 1.6;
      }
      
      .icp-link {
        a {
          color: #ffffff;
          font-size: 14px;
          text-decoration: none;
          transition: color 0.3s ease;
          
          &:hover {
            color: #d4edff;
            text-decoration: underline;
          }
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .app-header .header-content,
  .app-main,
  .app-footer .footer-content,
  .app-footer .footer-copyright .copyright-content {
    width: 95%;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .app-header .header-content {
    flex-direction: column;
    padding: 10px;
    
    .logo-section {
      margin-bottom: 10px;
      
      .logo-img {
        height: 50px;
      }
    }
    
    .nav-menu {
      width: 100%;
      justify-content: center;
      
      .nav-item {
        padding: 0 15px;
        font-size: 14px;
        height: 50px;
        line-height: 50px;
      }
    }
  }
  
  .app-main {
    margin: 10px auto;
    padding: 0 10px !important;
  }
  
  .app-footer .footer-content {
    padding: 20px 0 10px;
    
    .footer-links .links-container {
      flex-direction: column;
      
      .link-column,
      .qr-column {
        padding: 0 15px;
        margin-bottom: 20px;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  
  .app-footer .footer-copyright .copyright-content {
    flex-direction: column;
    text-align: center;
    
    .copyright-text,
    .icp-link {
      margin-bottom: 10px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

</style>
